import React from "react";
import classes from "./ProjectCard.module.css";
import toastr from "toastr";
import { useNavigate } from "react-router-dom";

const ProjectCard = (props) => {
  const navigate = useNavigate();
  console.log(props.video);

  return (
    <div
      className={
        props.display
          ? `${classes.projectCard}`
          : [`${classes["transparent-100"]} ${classes.projectCard}`]
      }
    >
      <img src={props.image} className={classes.img}></img>
      <div className={classes.textContainer}>
        <h4>{props.title}</h4>
        <p>{props.content}</p>
        <div className={classes.btnContainer}>
          {props.onOpen && (
            <button
              onClick={() => {
                props.onOpen(props.video);
              }}
              className={classes.btn}
            >
              Preview
            </button>
          )}
          <button
            className={classes.btn}
            style={{ width: !props.onOpen ? "90%" : "47%" }}
            onClick={() => {
              if (props.link) {
                window.open(props.link);
              } else {
                toastr.info("This repository is private", "INFO");
              }
            }}
          >
            View Code
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
